<template>
  <div class="jobs">
    <div class="banner"></div>

    <!-- 搜索 -->
    <div
      ref="searchBar"
      :class="{ fixedTop: searchBarFixedTop }"
      class="search-wrapper"
    >
      <input-search
        :size="searchBarFixedTop ? 'small' : 'medium'"
        placeholder="搜索职位"
        v-model="searchKeyword"
      ></input-search>
    </div>

    <div class="main clearfix">
      <!-- 条件筛选 -->
      <div class="screen-wrapper">
        <div class="CationBox">
          <!-- 城市 -->
          <div class="row-city">
            <div class="name">城市：</div>
            <div class="content-city">
              <div
                v-for="(item, index) in cityList"
                :key="index"
                @click="citySubmit(item.areaCode)"
                :class="['item', cityVar == item.areaCode ? 'actvCss' : '']"
              >
                {{ item.areaName }}
              </div>
            </div>
          </div>
          <!-- 残疾类型 -->
          <div class="row">
            <div class="name">残疾类型：</div>
            <div class="content">
              <div
                v-for="(item, index) in disabledTypeList"
                :key="index"
                @click="disabledTypeSubmit(item)"
                :class="['item', disabledTypeVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <!-- 残疾等级 -->
          <div class="row">
            <div class="name">残疾等级：</div>
            <div class="content">
              <div
                v-for="(item, index) in disabledLevelList"
                :key="index"
                @click="disabledLevelSubmit(item)"
                :class="[
                  'item',
                  disabledLevelVar.includes(item) ? 'actvCss' : '',
                ]"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <!-- 薪资 -->
          <div class="row">
            <div class="name">薪资：</div>
            <div class="content">
              <div
                v-for="(item, index) in salaryList"
                :key="index"
                @click="salarySubmit(item.value)"
                :class="['item', salaryVar == item.value ? 'actvCss' : '']"
              >
                {{ item.label }}
              </div>
              <div class="item-input" v-if="show">
                <el-input
                  class="input"
                  size="small"
                  min="1"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-model="salaryStart"
                >
                  <template
                    slot="append"
                    v-if="salaryVar == '1' || salaryVar == '2'"
                    >K</template
                  >
                </el-input>
                <span style="padding-right: 10px">-</span>
                <el-input
                  class="input"
                  size="small"
                  min="1"
                  oninput="value=value.replace(/[^\d]/g,'')"
                  v-model="salaryEnd"
                >
                  <template
                    slot="append"
                    v-if="salaryVar == '1' || salaryVar == '2'"
                    >K</template
                  >
                </el-input>
                <el-button type="primary" size="mini" @click="salarySub"
                  >确定</el-button
                >
              </div>
            </div>
          </div>
          <!-- 经验 -->
          <div class="row">
            <div class="name">经验：</div>
            <div class="content">
              <div
                v-for="(item, index) in termList"
                :key="index"
                @click="termVar = item"
                :class="['item', termVar == item ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <!-- 学历 -->
          <div class="row">
            <div class="name">学历：</div>
            <div class="content">
              <div
                v-for="(item, index) in educationList"
                :key="index"
                @click="educationSubmit(item)"
                :class="['item', educationVar.includes(item) ? 'actvCss' : '']"
              >
                {{ item }}
              </div>
            </div>
          </div>
          <div
            class="screen-row"
            v-if="
              cityVar != '全部' ||
              disabledType != '' ||
              !educationVar.includes('全部') ||
              termVar != '全部' ||
              salaryType != ''
            "
          >
            <div class="name">已选择：</div>
            <div class="content">
              <!-- 城市 -->
              <div
                class="item actvCss"
                v-if="cityVar != '全部'"
                @click="clearCity"
              >
                {{ cityList.find((item) => item.areaCode == cityVar).areaName
                }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <!-- 残疾类型 -->
              <div
                class="item actvCss"
                v-if="disabledType != ''"
                @click="clearDisabled"
              >
                {{ disabledType }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <!-- 学历 -->
              <div
                class="item actvCss"
                v-for="(item, i) in educationVar"
                @click="clearEducation(item)"
                v-if="item != '全部'"
              >
                {{ item }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <!-- 经验 -->
              <div
                class="item actvCss"
                v-if="termVar != '全部'"
                @click="termVar = '全部'"
              >
                {{ termVar }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <!-- 薪资类型 -->
              <div class="item actvCss" v-if="salaryType != ''" @click="onCear">
                {{ salaryList.find((item) => item.value == salaryType).label
                }}<i class="el-icon-close el-icon--right"></i>
              </div>
              <!-- 薪资 -->
              <div class="item actvCss" v-if="salary != ''" @click="onCear">
                {{ salary }}<i class="el-icon-close el-icon--right"></i>
              </div>
            </div>
            <div>
              <el-button
                type="text"
                icon="el-icon-delete-solid"
                @click="clearFilter"
                >清空筛选条件</el-button
              >
            </div>
          </div>
        </div>
      </div>
      <!-- 主体内容 -->
      <div class="content" v-loading:#ffffff7d.scrollFixed="loading">
        <ul class="content-list">
          <li
            class="recommend-job-item"
            v-for="(item, index) in jobsList"
            :key="index"
          >
            <a :href="'/jobDetail/' + item.jobId" target="_blank">
              <div class="job-top-container">
                <div class="job-top">
                  <h3 class="job-name">{{ item.job }}</h3>
                  <h3 class="wage">{{ item.startSalary }}</h3>
                </div>
                <div class="job-bottom substring">
                  <span class="tag" v-if="item.workingPlace">{{
                    item.workingPlace
                  }}</span
                  ><span class="tag" v-if="item.educationName">{{
                    item.educationName
                  }}</span
                  ><span class="tag" v-if="item.serviceName">{{
                    item.serviceName
                  }}</span>
                </div>
                <div class="job-bottom substring">
                  <span
                    v-for="(ite, i) in item.disabilities"
                    class="block"
                    :style="{ backgroundColor: getTagColor(ite) }"
                    >{{ ite }}</span
                  >
                </div>
              </div>
            </a>
            <div class="company-bottom">
              <div class="company-desc">
                <a
                  :href="'/companyDetail/' + item.companyId"
                  target="_blank"
                  class="company-t"
                >
                  <img
                    v-if="item.reCompanyLogo"
                    :src="item.reCompanyLogo"
                    alt=""
                    class="company-logo"
                  />
                  <div
                    v-else
                    class="company-title"
                    :style="{ backgroundColor: getColorById(item.companyId) }"
                  >
                    {{ item.companyName.slice(0, 4) }}
                  </div>
                  <div class="company-name substring">
                    {{ item.companyName }}
                  </div>
                </a>
              </div>
            </div>
          </li>
        </ul>
        <!-- 分页器 -->
        <div class="pagination-wrapper">
          <pagination
            v-show="total > 0"
            :total="total"
            :page.sync="queryFilter.params.pageNum"
            :limit.sync="queryFilter.params.pageSize"
            @pagination="getList"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getOffsetTop,
  getTagColor,
  getColorById,
  formatDisabilityData,
  handleTree,
} from "@/helper/utilities";
let positionY = 0;
let searchBarClientHeight = 0;
import {
  getJobsList,
  getDisabledStatus,
  getPreviewUrl,
  areaInfoHuBeiList,
} from "@/api/index.js";
import { groupBy } from "lodash";
export default {
  name: "jobs",
  metaInfo: {
    title: "湖北省残疾人求职招聘信息平台",
    meta: [
      { charset: "utf-8" },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      { hid: "description", name: "description", content: "职位" },
      {
        name: "keywords",
        content: "湖北残联网, 湖北省残疾人求职招聘信息平台",
      },
    ],
  },
  data() {
    return {
      cityLists: [],
      cityList: [],
      disabledTypeList: [
        "全部",
        "视力残疾",
        "听力残疾",
        "言语残疾",
        "肢体残疾",
        "智力残疾",
        "精神残疾",
        "多重残疾",
      ],
      disabledLevelList: ["全部", "一级", "二级", "三级", "四级"],
      educationList: [
        "全部",
        "博士",
        "硕士",
        "本科",
        "大专",
        "中专",
        "高中",
        "初中及以下",
        "其他",
      ],
      termList: [
        "全部",
        "无工作经验",
        "1年以下工作经验",
        "1年-3年工作经验",
        "3年-5年工作经验",
        "5年-10年工作经验",
        "10年以上工作经验",
      ],
      salaryList: [
        {
          value: "全部",
          label: "全部",
        },
        {
          value: "0",
          label: "面议",
        },
        {
          value: "1",
          label: "月薪",
        },
        {
          value: "2",
          label: "年薪",
        },
        {
          value: "3",
          label: "日薪",
        },
        {
          value: "4",
          label: "时薪",
        },
      ],
      show: false,
      cityVar: "全部",
      cityCode: [],
      disabledTypeVar: "全部",
      disabledLevelVar: ["全部"],
      reJobDisabledReturnEntityList: [],
      disabledType: "",
      educationVar: ["全部"], // 表示当前选中的学历
      educationNameForSearch: [],
      termVar: "全部", // 表示当前选中的经验
      salaryVar: "全部", // 表示当前选中的薪资
      salaryType: "",
      salaryStart: "",
      salaryEnd: "",
      salaryStartForSearch: "",
      salaryEndForSearch: "",
      salary: "",
      jobsList: [],
      // 查询参数
      searchKeyword: "",
      currentPage: 1,
      // 总条数
      total: 0,
      searchBarFixedTop: false,
      loading: false,
    };
  },
  computed: {
    queryFilter() {
      let serviceName;
      if (this.termVar == "全部") {
        serviceName = "";
      } else {
        serviceName = this.termVar;
      }
      let educationNameForSearchStr;
      if (this.educationVar == "全部") {
        educationNameForSearchStr = "";
      } else {
        educationNameForSearchStr = this.educationVar.toString();
      }
      return {
        areaIdArrForSearch: this.cityCode,
        params: {
          pageNum: 1,
          pageSize: 10,
        },
        reJobDisabledReturnEntityList: this.reJobDisabledReturnEntityList,
        educationNameForSearchStr: educationNameForSearchStr,
        serviceName: serviceName,
        salaryType: this.salaryType,
        salaryStartForSearch: this.salaryStartForSearch,
        salaryEndForSearch: this.salaryEndForSearch,
        search: this.searchKeyword || "",
      };
    },
  },
  watch: {
    queryFilter(newVal, oldVal) {
      this.searchBarFixedTop && window.scrollTo(0, positionY);
      this.getList();
    },
  },
  mounted() {
    this.$nextTick(() => {
      positionY = getOffsetTop(document.body, this.$refs.searchBar);

      searchBarClientHeight = this.$refs.searchBar.clientHeight;
    });
    const onPageScroll = () => {
      const top = this.$refs.searchBar.getBoundingClientRect().top;

      this.searchBarFixedTop =
        window.scrollY > positionY - searchBarClientHeight / 2;
    };
    window.addEventListener("scroll", onPageScroll);

    this.$on("hook:destroyed", () => {
      window.removeEventListener("scroll", onPageScroll);
    });
  },
  created() {
    this.getAreaInfo();
    this.getList();
  },
  methods: {
    getTagColor,
    getColorById,
    //获取地区
    getAreaInfo() {
      areaInfoHuBeiList().then((res) => {
        let list = handleTree(res.data, "areaId", "parentId");
        this.cityLists = this.changeAreaInfoListFiled(list);
        const data = res.data.filter((item) => item.level !== "3");
        const allOption = {
          params: { "@type": "java.util.HashMap" },
          areaId: "0",
          areaCode: "全部",
          areaName: "全部",
          level: "0",
          cityCode: "[]",
          center: "",
          parentId: "-1",
        };
        this.cityList = [allOption, ...data];
      });
    },

    changeAreaInfoListFiled(list) {
      let newList = [];
      if (list && list.length > 0) {
        list.forEach((t) => {
          let newItem = {
            label: t.areaName,
            value: t.areaCode,
            parentId: t.parentId,
            areaCode: t.areaCode,
            children: t.children,
          };
          newList.push(newItem);
          if (t.children && t.children.length > 0) {
            newItem.children = this.changeAreaInfoListFiled(t.children);
          }
        });
      }
      return newList;
    },

    clearFilter() {
      this.show = false;
      this.cityVar = "全部";
      this.cityCode = [];
      (this.disabledTypeVar = "全部"), (this.disabledLevelVar = ["全部"]);
      this.disabledType = "";
      this.reJobDisabledReturnEntityList = [];
      this.educationVar = ["全部"];
      this.termVar = "全部";
      this.salaryVar = "全部";
      this.salary = "";
      this.salaryType = "";
      this.salaryStart = "";
      this.salaryEnd = "";
      this.salaryStartForSearch = "";
      this.salaryEndForSearch = "";
    },

    // 清除城市
    clearCity() {
      this.flag = false;
      this.cityVar = "全部";
      this.cityCode = [];
    },

    //城市选择
    citySubmit(item) {
      this.cityCode = [];
      if (item == "全部") {
        this.city = "";
      } else {
        this.cityCode.push(item);
        this.findAreaWithChildren(this.cityLists, item);
      }
      this.cityVar = item;
    },

    /**
     * 递归查找areaCode对应的节点及其下级areaCode
     * @param {Array} nodes 节点数组
     * @param {String} targetAreaCode 要查找的areaCode
     */
    findAreaWithChildren(nodes, targetAreaCode) {
      for (const node of nodes) {
        if (node.areaCode === targetAreaCode) {
          this.collectChildrenAreaCodes(node);
          return;
        }
        if (node.children && node.children.length > 0) {
          this.findAreaWithChildren(node.children, targetAreaCode);
        }
      }
    },

    /**
     * 收集所有子节点的areaCode
     * @param {Object} node 当前节点
     */
    collectChildrenAreaCodes(node) {
      if (!node.children || node.children.length === 0) return;

      for (const child of node.children) {
        this.cityCode.push(child.areaCode);
        // 递归收集所有后代
        this.collectChildrenAreaCodes(child);
      }
    },

    //薪资清空
    onCear() {
      this.salaryVar = "全部";
      this.show = false;
      this.salary = "";
      this.salaryType = "";
      this.salaryStart = "";
      this.salaryEnd = "";
      this.salaryStartForSearch = "";
      this.salaryEndForSearch = "";
    },
    //薪资类型选择
    salarySubmit(val) {
      let found = this.salaryList.find((item) => item.value == val);
      if (val == "全部") {
        this.show = false;
        this.salary = "";
        this.salaryType = "";
        this.salaryStart = "";
        this.salaryEnd = "";
        this.salaryStartForSearch = "";
        this.salaryEndForSearch = "";
      } else if (val == "0") {
        this.show = false;
        this.salaryType = found.value;
        this.salaryStart = "";
        this.salaryEnd = "";
        this.salaryStartForSearch = "";
        this.salaryEndForSearch = "";
        this.salary = "";
      } else {
        this.show = true;
      }
      this.salaryVar = found.value;
    },

    //薪资选择
    salarySub() {
      if (this.salaryStart && this.salaryEnd && this.salaryVar) {
        if (this.salaryVar == "3" || this.salaryVar == "4") {
          this.salaryStartForSearch = this.salaryStart;
          this.salaryEndForSearch = this.salaryEnd;
          this.salary = this.salaryStart + "-" + this.salaryEnd;
        } else {
          this.salaryStartForSearch = this.salaryStart + "000";
          this.salaryEndForSearch = this.salaryEnd + "000";
          this.salary = this.salaryStart + "-" + this.salaryEnd + "K";
        }
        if (this.salaryVar == "全部") {
          this.salaryType = "";
        } else if (this.salaryVar == "0") {
          this.salaryType = "";
        } else {
          this.salaryType = this.salaryVar;
        }
      } else {
        this.$message({
          showClose: true,
          message: "薪资范围不能为空",
          type: "warning",
        });
      }
    },

    //残疾类型选择
    disabledTypeSubmit(item) {
      if (item == "全部") {
        this.disabledTypeVar = "全部";
        this.disabledLevelVar = ["全部"];
        this.disabledType = "";
        this.reJobDisabledReturnEntityList = [];
      }
      this.disabledTypeVar = item;
      if (!this.disabledLevelVar.includes("全部")) {
        this.reJobDisabledReturnEntityList = [
          {
            disabledType: this.disabledTypeVar,
            disabledLevel: [...this.disabledLevelVar],
          },
        ];
        this.disabledType = this.formatSingleItem(
          this.reJobDisabledReturnEntityList[0]
        );
      }
    },

    //残疾等级选择
    disabledLevelSubmit(val) {
      if (this.disabledTypeVar != "全部") {
        if (val == "全部") {
          this.disabledLevelVar = ["全部"];
          this.disabledType = "";
          this.reJobDisabledReturnEntityList = [];
        } else {
          const filteredArray = this.disabledLevelVar.filter(
            (item) => item !== "全部"
          );
          filteredArray.push(val);
          this.disabledLevelVar = filteredArray.filter(
            (item, index) => filteredArray.indexOf(item) === index
          );
          this.reJobDisabledReturnEntityList = [
            {
              disabledType: this.disabledTypeVar,
              disabledLevel: [...this.disabledLevelVar],
            },
          ];
          this.disabledType = this.formatSingleItem(
            this.reJobDisabledReturnEntityList[0]
          );
        }
      } else {
        this.$message({
          showClose: true,
          message: "请先选择残疾类型",
          type: "warning",
        });
      }
    },

    //残疾类型转换
    formatSingleItem(item) {
      // 验证数据结构
      if (
        !item.disabledType ||
        !item.disabledLevel ||
        !Array.isArray(item.disabledLevel)
      ) {
        this.$message.error("输入数据格式不正确");
        return "";
      }

      // 等级映射表
      const levelMap = {
        一级: "1",
        二级: "2",
        三级: "3",
        四级: "4",
      };

      // 转换等级为数字并排序
      const levels = item.disabledLevel
        .map((level) => levelMap[level] || level)
        .sort((a, b) => a - b);

      // 判断是否为连续等级
      let formattedLevels;
      if (this.isConsecutive(levels)) {
        formattedLevels = `${levels[0]}-${levels[levels.length - 1]}`;
      } else {
        formattedLevels = levels.join(",");
      }

      // 生成结果
      return `${item.disabledType}${formattedLevels}级`;
    },

    // 判断数字是否连续
    isConsecutive(numbers) {
      if (numbers.length < 2) return false;

      for (let i = 1; i < numbers.length; i++) {
        if (parseInt(numbers[i]) !== parseInt(numbers[i - 1]) + 1) {
          return false;
        }
      }
      return true;
    },

    //残疾类型清除
    clearDisabled() {
      this.disabledTypeVar = "全部";
      this.disabledLevelVar = ["全部"];
      this.disabledType = "";
    },

    //学历选择
    educationSubmit(val) {
      if (val == "全部") {
        this.educationVar = ["全部"];
      } else {
        const filteredArray = this.educationVar.filter(
          (item) => item !== "全部"
        );
        filteredArray.push(val);
        this.educationVar = filteredArray.filter(
          (item, index) => filteredArray.indexOf(item) === index
        );
      }
    },

    //学历清空
    clearEducation(val) {
      const filteredArray = this.educationVar.filter((item) => item !== val);
      this.educationVar = filteredArray;
      if (this.educationVar.length == 0) {
        this.educationVar = ["全部"];
      }
    },

    getList() {
      const loading = this.$loading();
      getJobsList(this.queryFilter)
        .then(async (response) => {
          loading.close();
          // 1. 提取所有 jobId
          let jobIds = response.data.map((item) => item.jobId);
          // 2. 根据 jobIds 异步获取残疾标签数据
          await this.fetchDisabilityLabels(response.data, jobIds);
          this.total = response.total;
        })
        .catch(() => {
          loading.close();
        });
    },

    //3，获取对应数据的残疾标签
    fetchDisabilityLabels(dataList, jobIds) {
      if (jobIds.length > 0) {
        getDisabledStatus(jobIds).then((res) => {
          const result = {};
          Object.keys(res.data).forEach((jobId) => {
            const grouped = groupBy(res.data[jobId], "disabledType");
            result[jobId] = Object.entries(grouped).map(([type, items]) => ({
              disabledType: type,
              disabledLevel: [
                ...new Set(items.map((item) => item.disabledLevel)),
              ],
            }));
          });

          const formattedData = formatDisabilityData(result);
          this.jobsList = dataList.map((job, i) => {
            if (job.reCompanyLogo) {
              this.PreviewLogoUrl(job.reCompanyLogo, i);
            }
            // 找到当前jobId对应的残疾数据
            const disabilities = formattedData[job.jobId] || [];
            return {
              ...job,
              disabilities, // 将残疾数据添加到职位对象中
            };
          });
        });
      } else {
        this.jobsList = [];
      }
    },

    //获取岗位列表公司logo
    async PreviewLogoUrl(reCompanyLogo, i) {
      await getPreviewUrl(reCompanyLogo).then((response) => {
        this.jobsList[i].reCompanyLogo = response.msg;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.jobs {
  background-color: #f3f3f3;
  padding-bottom: 30px;
}
.banner {
  padding-bottom: 32%;
  line-height: 400px;
  color: #fff;
  width: 100%;
  min-width: @main-width;
  background-image: url("../assets/images/yssdpc.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  text-align: center;
  font-size: @font-size-larger;
}
.search-wrapper {
  // position: absolute;
  width: 100%;
  // padding: 0 200px;
  transform: translateY(-50%);
  z-index: 100;
  &.fixedTop {
    position: fixed;
    box-shadow: 0 5px 4px rgba(0, 0, 0, 0.1);
    top: 0;
    padding: 20px 130px;
    z-index: 1000;
    background-color: #fff;
    transform: translateY(0);
  }
}

.main {
  width: @main-width;
  margin: 0 auto;
  .screen-wrapper {
    width: @main-width;
    padding: 0 auto;
    .CationBox {
      width: @main-width;
      background-color: #fff;
      border-radius: 4px;
      padding: 30px 32px 18px;
    }
    .row .name {
      flex-shrink: 0;
      width: 70px;
      font-size: 14px;
    }
    .row {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #f3f3f3;
    }
    .row-city {
      width: 100%;
      height: 100px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      border-bottom: 1px solid #f3f3f3;
    }
    .row-city .name {
      flex-shrink: 0;
      width: 70px;
      font-size: 14px;
    }
    .content-city {
      .item {
        float: left;
        border-radius: 3px;
        color: #666;
        padding: 5px 15px;
        margin: 5px 0;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        border: 1px solid transparent;
      }
      .actvCss {
        background: #39b8ff;
        color: #fff;
        margin-right: 5px;
      }
    }
    .content {
      flex: 1;
      display: flex;
      .item {
        border-radius: 3px;
        color: #666;
        padding: 5px 15px;
        margin: 5px 0;
        font-size: 14px;
        cursor: pointer;
        user-select: none;
        border: 1px solid transparent;
      }
      .item-input {
        margin-left: 20px;
        margin: 5px 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        .input {
          width: 120px;
          height: 31px;
          margin-right: 10px;
          border-radius: 5px;
        }
      }
      .actvCss {
        background: #39b8ff;
        color: #fff;
        margin-right: 5px;
      }
    }
    .screen-row > div {
      flex-shrink: 0;
      font-size: 14px;
    }
    .screen-row {
      width: 100%;
      height: 50px;
      display: flex;
      align-items: center;
      padding: 0px 10px;
      .item {
        margin: 0 5px;
      }
    }
  }

  .recommend-job-item:nth-child(2n) {
    margin-right: 0;
  }
  .recommend-job-item {
    background-color: #fff;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    margin-bottom: 21px;
    margin-right: 20px;
    padding: 13px 25px;
    width: 45%;
  }

  .pagination-wrapper {
    text-align: center;
  }
}
</style>
